import angular from 'angular';
import { GroupsConstants } from './GroupsConstants';
//Controllers
import { GroupsController } from './GroupsController';
import { GroupDetailsController } from './details/GroupDetailsController';
//Views
import GroupsView from './GroupsView.html';
import GroupDetailsView from './details/GroupDetailsView.html';
import { GroupsFeatures } from './GroupsFeatures';
import { growthState } from '..';
import { GroupsService } from './GroupsService';
import { GroupsSegmentService } from './GroupsSegmentService';
export const groups = angular
    .module('groups', ['ui.router'])
    .service('GroupsService', GroupsService)
    .service('GroupsSegmentService', GroupsSegmentService)
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state(GroupsConstants.GROUPS_STATE, {
            url: '/groups',
            views: {
                'content@auth.application.detail': {
                    template: GroupsView,
                    controller: GroupsController,
                    controllerAs: '$ctrl',
                },
            },
            params: { area: 'groups' },
            onEnter: ['$state', async function ($state) {
                    const isShowWhatsAppGroupViewEnabled = await GroupsFeatures.isShowWhatsAppGroupViewEnabled();
                    if (isShowWhatsAppGroupViewEnabled) {
                        return $state.go(GroupsConstants.GROUPS_STATE);
                    }
                    else {
                        return $state.go(growthState);
                    }
                }],
        }).state(GroupsConstants.GROUP_DETAILS_STATE, {
            url: '/:id',
            views: {
                'content@auth.application.detail': {
                    template: GroupDetailsView,
                    controller: GroupDetailsController,
                    controllerAs: '$ctrl',
                },
            },
            params: { area: 'groups' },
            onEnter: ['$state', async function ($state) {
                    const isShowWhatsAppGroupViewEnabled = await GroupsFeatures.isShowWhatsAppGroupViewEnabled();
                    if (isShowWhatsAppGroupViewEnabled) {
                        return $state.go(GroupsConstants.GROUP_DETAILS_STATE);
                    }
                    else {
                        return $state.go(growthState);
                    }
                }],
        });
    }]).name;
